import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'synergy-footer',
  templateUrl: './synergy-footer.component.html',
  styleUrls: ['./synergy-footer.component.sass']
})
export class SynergyFooterComponent {
  year = new Date().getFullYear();
  applicayionId!: number;

  constructor(
    private messageService: MessageService) { 
      this.applicayionId = environment.applicayionId;
    }

  onSubscribe(event: any) {
    if (event) {
      this.messageService.add({ key: 'tc', severity: 'info', summary: 'Correo enviado exitosamente', detail: 'Se ha subscrito correctament a nuestro boletin.' });
    } else {
      this.messageService.add({ key: 'tc', severity: 'error', summary: "Se ha producido un error", detail: 'No hemos podido procesar su solicitd' });
    }
  }
}